import TerminalContainerContext, {type TerminalTab} from "./TerminalContainerContext.ts";
import {type CSSProperties, useContext, useEffect, useRef} from "react";

interface TerminalContainerXTermPanelProps {
    tab: TerminalTab;
    style?: CSSProperties;
}

export default function TerminalContainerXTermPanel(props: TerminalContainerXTermPanelProps) {
    const tab = props.tab;
    const context = useContext(TerminalContainerContext)!;
    const terminalSurfaceRef = useRef<HTMLDivElement>(null);

    function onDataXterm(data: string) {
        context.writeToStdInByTabKey(tab.tabKey!, data);
    }

    useEffect(() => {
        const xterm = tab.xterm;
        if (!xterm || !terminalSurfaceRef.current) return;

        if (!tab.bounded) {
            xterm.open(terminalSurfaceRef.current);
            tab.xterm.loadAddon(tab.xtermFitAddon);
            tab.xterm.loadAddon(tab.webLinksAddon);
            tab.xterm.loadAddon(tab.xtermSearchAddon);
            try {
                tab.xterm.loadAddon(tab.webglAddon);
            } catch (e) {
                console.warn(e);
            }

            xterm.onData(onDataXterm);
            context.setBounded(tab.reqKey, true);
        }
    });


    const style: CSSProperties = {
        ...context.activeTab?.reqKey === tab.reqKey ? {display: 'block'} : {display: 'none'},
        ...props.style,
        backgroundColor: context.themeSet.defaultTheme.background,
    };

    if (!tab.tabKey) return (
        <div className="text-center terminal-surface" style={style}>
            <div className="loading-spinner mt-3">
                {tab.tabKey}
            </div>
        </div>
    );

    return (
        <div className="terminal-surface" ref={terminalSurfaceRef} style={style}/>
    );
}